import type { ComponentProps } from "react"
import cn from "@/v2-ui/utils/utils.cn"
import DropdownMenu from "@/v2-ui/dropdownMenu"

export type ActionMenuContentProps = ComponentProps<typeof DropdownMenu.Content>

function ActionMenuContent(props: ActionMenuContentProps) {
  const { className, ...rest } = props
  return (
    <DropdownMenu.Content
      className={cn("action-menu-content", className)}
      align="start"
      {...rest}
    />
  )
}

export default ActionMenuContent
